module.exports = require("@agm/core/services/managers/rectangle-manager");